module.exports = __webpack_public_path__ + "ee6539921d713482b8ccd4d0d23961bb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-Regular.ttf
// module id = 1801
// module chunks = 1